(function(){
var d=document;
function $(s,r){return (r||d).querySelector(s)}
function $$(s,r){return Array.prototype.slice.call((r||d).querySelectorAll(s))}

function initGallery(root){
  if(root.__be)return;root.__be=1;
  var main=$('[data-be-gal-main]',root),thumbs=$('[data-be-thumbs]',root);
  if(!main)return;
  var slides=$$('.be-gal-slide',main),ths=thumbs?$$('.be-th',thumbs):[];
  var cur=0,lock=false,lt;
  function idx(){return Math.max(0,Math.min(slides.length-1,Math.round(main.scrollLeft/(main.clientWidth||1))))}
  function vis(){var h=root.closest('[data-be-hero]');return parseInt(getComputedStyle(h).getPropertyValue('--thumbs'))||4}
  function setAct(i){
    cur=i;
    ths.forEach(function(t,k){t.classList.toggle('is-act',k===i)});
    if(thumbs&&ths[i]){
      var step=ths[1]?ths[1].offsetLeft-ths[0].offsetLeft:ths[0].offsetWidth,n=vis();
      var page=Math.floor(i/n)*n;
      thumbs.scrollTo({left:Math.min(page*step,thumbs.scrollWidth-thumbs.clientWidth),behavior:'smooth'});
    }
  }
  function go(i){i=Math.max(0,Math.min(slides.length-1,i));lock=true;clearTimeout(lt);lt=setTimeout(function(){lock=false},800);main.scrollTo({left:i*main.clientWidth,behavior:'smooth'});setAct(i)}
  var tm;main.addEventListener('scroll',function(){if(lock)return;clearTimeout(tm);tm=setTimeout(function(){if(lock)return;var i=idx();if(i!==cur)setAct(i)},60)},{passive:true});
  main.addEventListener('scrollend',function(){lock=false;clearTimeout(lt);var i=idx();if(i!==cur)setAct(i)});
  ths.forEach(function(t,i){t.addEventListener('click',function(){go(i)})});
  var p=$('[data-be-gal-prev]',root),n=$('[data-be-gal-next]',root);
  if(p)p.addEventListener('click',function(){go(cur-1)});
  if(n)n.addEventListener('click',function(){go(cur+1)});
  var tp=$('[data-be-th-prev]',root),tn=$('[data-be-th-next]',root);
  function tby(dir){if(!thumbs)return;var step=ths[1]?ths[1].offsetLeft-ths[0].offsetLeft:ths[0].offsetWidth;thumbs.scrollBy({left:dir*step*vis(),behavior:'smooth'})}
  if(tp)tp.addEventListener('click',function(){tby(-1)});
  if(tn)tn.addEventListener('click',function(){tby(1)});
}

function initBundle(root){
  if(root.__be)return;root.__be=1;
  var opts=$$('[data-be-opt]',root),form=root.closest('form'),vid=form&&$('[data-be-vid]',form),btn=form&&$('[data-be-submit]',form);
  function sel(o){
    opts.forEach(function(x){var on=x===o;x.classList.toggle('is-sel',on);x.setAttribute('aria-checked',on?'true':'false')});
    if(vid)vid.value=o.getAttribute('data-vid');
    if(btn){var ok=o.getAttribute('data-avail')==='true';btn.disabled=!ok;btn.textContent=ok?btn.getAttribute('data-label'):btn.getAttribute('data-out')}
  }
  opts.forEach(function(o){
    o.addEventListener('click',function(){sel(o)});
    o.addEventListener('keydown',function(e){if(e.key==='Enter'||e.key===' '){e.preventDefault();sel(o)}});
  });
  var s=opts.filter(function(o){return o.classList.contains('is-sel')})[0]||opts[0];
  if(s)sel(s);
}

function initReviews(root){
  if(root.__be)return;root.__be=1;
  var tr=$('[data-be-rev-track]',root);if(!tr)return;
  var cards=$$('.be-rev',tr),dots=$('[data-be-rev-dots]',root),ds=[];
  function stepW(){var c=tr.firstElementChild;return c?c.getBoundingClientRect().width+16:1}
  function by(dir){tr.scrollBy({left:dir*stepW(),behavior:'smooth'})}
  var p=$('[data-be-rev-prev]',root),n=$('[data-be-rev-next]',root);
  if(p)p.addEventListener('click',function(){by(-1)});
  if(n)n.addEventListener('click',function(){by(1)});
  if(dots){
    cards.forEach(function(c,i){var b=d.createElement('button');b.type='button';b.setAttribute('aria-label','Review '+(i+1));b.addEventListener('click',function(){tr.scrollTo({left:i*stepW(),behavior:'smooth'})});dots.appendChild(b);ds.push(b)});
    var tm;function upd(){var i=Math.max(0,Math.min(cards.length-1,Math.round(tr.scrollLeft/stepW())));ds.forEach(function(b,k){b.classList.toggle('is-act',k===i)})}
    tr.addEventListener('scroll',function(){clearTimeout(tm);tm=setTimeout(upd,50)},{passive:true});upd();
  }
}

function initSticky(el){
  if(el.__be)return;el.__be=1;
  d.body.classList.add('has-sticky');
  var hero=$('[data-be-hero]')||$('#be-bundle');
  function chk(){
    var ref=$('#be-buy')||hero;var on=ref?ref.getBoundingClientRect().bottom<0:window.scrollY>600;
    el.classList.toggle('is-on',on);el.setAttribute('aria-hidden',on?'false':'true');
  }
  window.addEventListener('scroll',chk,{passive:true});window.addEventListener('resize',chk);chk();
}


/* cart drawer */
var CART=null,SID=null;
function cartEl(){return CART||(CART=$('[data-be-cart]'))}
function setBusy(b){var c=cartEl();if(c)c.classList.toggle('is-busy',!!b)}
function openCart(){var c=cartEl();if(!c)return false;c.classList.add('is-open');c.setAttribute('aria-hidden','false');d.body.classList.add('be-lock');return true}
function closeCart(){var c=cartEl();if(!c)return;c.classList.remove('is-open');c.setAttribute('aria-hidden','true');d.body.classList.remove('be-lock')}
function setCount(n){
  $$('.be-hd-cart').forEach(function(a){
    var s=$('.be-hd-count',a);
    if(n>0){if(!s){s=d.createElement('span');s.className='be-hd-count';a.appendChild(s)}s.textContent=n}else if(s){s.remove()}
  });
}
function apply(res){
  var c=cartEl();if(!c)return;
  var h=res&&res.sections&&res.sections[SID];
  if(h){
    var t=d.createElement('div');t.innerHTML=h;var n=t.querySelector('[data-be-cart]');
    if(n){
      ['data-count','data-bonus-keys','data-cart-bonus-vids','data-parent-n','data-shown','data-upsell-key'].forEach(function(k){c.setAttribute(k,n.getAttribute(k)||'')});
      c.innerHTML=n.innerHTML;
    }
  }
  setCount(parseInt(c.getAttribute('data-count'))||0);
}
function post(url,body){
  body.sections=SID;
  return fetch(url,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(body)}).then(function(r){return r.json().then(function(j){if(!r.ok)throw j;return j})});
}
function tidy(res){
  /* remove free bonus lines when the main product is no longer in the cart */
  var c=cartEl();apply(res);
  var keys=(c.getAttribute('data-bonus-keys')||'').split(',').filter(Boolean);
  var up=c.getAttribute('data-upsell-key');
  var none=(parseInt(c.getAttribute('data-shown'))||0)===0;
  if(none&&up)keys.push(up);
  if(keys.length&&(none||(parseInt(c.getAttribute('data-parent-n'))||0)===0)){
    var u={};keys.forEach(function(k){u[k]=0});
    return post('/cart/update.js',{updates:u}).then(tidy);
  }
}
function cartChange(key,qty){setBusy(true);return post('/cart/change.js',{id:key,quantity:qty}).then(tidy).catch(function(){}).then(function(){setBusy(false)})}
function addItems(items){
  setBusy(true);
  return post('/cart/add.js',{items:items}).then(function(r){apply(r);openCart()}).then(function(){setBusy(false)},function(e){setBusy(false);throw e});
}
function initCart(){
  var c=cartEl();if(!c||c.__be)return;c.__be=1;SID=c.getAttribute('data-sid');
  c.addEventListener('click',function(e){
    var t=e.target;
    if(t.closest('[data-be-cart-close]')){closeCart();return}
    var rm=t.closest('[data-be-rm]');if(rm){e.preventDefault();cartChange(rm.getAttribute('data-be-rm'),0)}
  });
  c.addEventListener('change',function(e){
    var i=e.target.closest&&e.target.closest('[data-be-upsell]');if(!i)return;
    if(i.checked){setBusy(true);post('/cart/add.js',{items:[{id:parseInt(i.getAttribute('data-vid')),quantity:1}]}).then(apply).catch(function(){}).then(function(){setBusy(false)})}
    else{var k=i.getAttribute('data-key');if(k)cartChange(k,0)}
  });
  d.addEventListener('keydown',function(e){if(e.key==='Escape')closeCart()});
  d.addEventListener('click',function(e){
    var a=e.target.closest&&e.target.closest('.be-hd-cart');
    if(a&&cartEl()){e.preventDefault();openCart()}
  });
}
function bonusIds(){
  var f=$('[data-bonus-vids]');if(!f)return [];
  return (f.getAttribute('data-bonus-vids')||'').split(',').filter(Boolean);
}
d.addEventListener('submit',function(e){
  var f=e.target;
  if(!f.matches||!f.matches('form.be-form,form.be-offer-form')||f.__nojs||!cartEl())return;
  e.preventDefault();
  var idEl=$('[name=id]',f),vid=parseInt(idEl.value),qEl=$('[name=quantity]',f),q=qEl?parseInt(qEl.value)||1:1;
  var withBonus=false;
  if(f.classList.contains('be-form')){var o=$('[data-be-opt].is-sel',f);withBonus=!!(o&&o.getAttribute('data-bonus')==='true')}
  else{withBonus=f.getAttribute('data-add-bonus')==='true'}
  var ids=withBonus?bonusIds():[];
  var main={id:vid,quantity:q};if(withBonus&&ids.length)main.properties={_has_bonus:'1'};
  var items=[main];
  var have=(cartEl().getAttribute('data-cart-bonus-vids')||'').split(',');
  ids.forEach(function(b){if(have.indexOf(b)<0)items.push({id:parseInt(b),quantity:1,properties:{_bonus:'1'}})});
  var btn=$('button[type=submit]',f);if(btn)btn.disabled=true;
  addItems(items).then(function(){if(btn)btn.disabled=false},function(){f.__nojs=1;f.submit()});
},true);

function init(root){
  root=root||d;
  $$('[data-be-gal]',root).forEach(initGallery);
  $$('[data-be-bundle]',root).forEach(initBundle);
  $$('[data-be-rev]',root).forEach(initReviews);
  $$('[data-be-sticky]',root).forEach(initSticky);
  initCart();
}
if(d.readyState==='loading')d.addEventListener('DOMContentLoaded',function(){init()});else init();
d.addEventListener('shopify:section:load',function(e){init(e.target)});

d.addEventListener('click',function(e){
  var a=e.target.closest&&e.target.closest('a[href^="#"]');
  if(!a)return;var h=a.getAttribute('href');if(h.length<2)return;
  var t=d.querySelector(h);if(t){e.preventDefault();t.scrollIntoView({behavior:'smooth',block:'start'})}
});
})();
